import { isSameNodeProperty, type ViewConfigField, type ViewConfigSheet, type ViewConfigSorter } from '@salescore/core'

import type { GoalConfig } from './types.ts'

export function generateGoalViewConfig({
  pivotedGoalViewConfig,
  savedGoalConfig,
}: {
  pivotedGoalViewConfig: ViewConfigSheet
  savedGoalConfig: Pick<GoalConfig, 'config'>
}) {
  const savedConfig = savedGoalConfig.config
  if (savedConfig?.type !== 'sheet') {
    return pivotedGoalViewConfig
  }

  const fields = generateGoalViewConfigFields({
    fields: pivotedGoalViewConfig.fields,
    savedFields: savedConfig.fields,
  })

  const sorters = generateGoalViewConfigSorters({
    fields,
    savedSorters: savedConfig.sorters,
  })

  return {
    ...pivotedGoalViewConfig,
    fields,
    sorters,
    filterTree: savedConfig.filterTree,
    meta: savedConfig.meta,
  }
}

function generateGoalViewConfigFields({
  fields,
  savedFields,
}: {
  fields?: ViewConfigField[]
  savedFields?: ViewConfigField[]
}) {
  if (fields === undefined || savedFields === undefined) {
    return fields
  }
  // eslint-disable-next-line sonarjs/no-misleading-array-reverse
  const sortedFields = fields.sort((a, b) => {
    const aIndex = savedFields.findIndex((x) => isSameNodeProperty(x.property, a.property))
    const bIndex = savedFields.findIndex((x) => isSameNodeProperty(x.property, b.property))
    if (aIndex === -1) {
      return 1
    }
    if (bIndex === -1) {
      return -1
    }
    return aIndex - bIndex
  })
  return sortedFields.map((x) => ({
    ...x,
    ...savedFields.find((y) => isSameNodeProperty(y.property, x.property)),
  }))
}

function generateGoalViewConfigSorters({
  fields,
  savedSorters,
}: {
  fields?: ViewConfigField[]
  savedSorters?: ViewConfigSorter[]
}) {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  return savedSorters?.filter((x) => fields?.some((y) => isSameNodeProperty(y.property, x.property)))
}
